import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useNotifications } from '../contexts/NotificationContext';

export const NotificationPopup: React.FC = () => {
  const navigate = useNavigate();
  const { showNotificationPopup, newMatchStudent, markAsRead } = useNotifications();

  if (!showNotificationPopup || !newMatchStudent) {
    return null;
  }

  const handleViewRequests = () => {
    markAsRead();
    navigate('/profile/requests');
  };

  const handleDismiss = () => {
    markAsRead();
  };

  return (
    <div className="fixed top-4 right-4 z-50 animate-slide-in-right">
      <div className="bg-white border-l-4 border-red-500 rounded-lg shadow-2xl max-w-sm w-full p-4 transform transition-all duration-300 hover:scale-105">
        {/* Header avec icône de notification */}
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-10 h-10 bg-red-500 rounded-full flex items-center justify-center animate-pulse">
                <i className="fas fa-heart text-white text-lg"></i>
              </div>
            </div>
            <div className="ml-3">
              <h3 className="text-sm font-bold text-gray-900">
                Nouveau match ! 💕
              </h3>
              <p className="text-xs text-gray-600">
                Il y a quelques secondes
              </p>
            </div>
          </div>
          <button
            onClick={handleDismiss}
            className="text-gray-400 hover:text-gray-600 transition-colors"
          >
            <i className="fas fa-times text-sm"></i>
          </button>
        </div>

        {/* Contenu de la notification */}
        <div className="mb-4">
          <p className="text-sm text-gray-700">
                            <span className="font-semibold text-[#002c46]">
              {newMatchStudent.prenom} {newMatchStudent.nom}
            </span>{' '}
            vous a liké ! Consultez votre tableau de bord pour accepter ou refuser cette demande.
          </p>
        </div>

        {/* Actions */}
        <div className="flex space-x-2">
          <button
            onClick={handleViewRequests}
            className="flex-1 bg-red-500 text-white text-xs font-semibold py-2 px-3 rounded-lg hover:bg-red-600 transition-colors duration-200 flex items-center justify-center"
          >
            <i className="fas fa-eye mr-1"></i>
            Voir les demandes
          </button>
          <button
            onClick={handleDismiss}
            className="flex-1 bg-gray-100 text-gray-700 text-xs font-semibold py-2 px-3 rounded-lg hover:bg-gray-200 transition-colors duration-200"
          >
            Plus tard
          </button>
        </div>

        {/* Indicateur de progression (disparaît après 5 secondes) */}
        <div className="mt-3">
          <div className="w-full bg-gray-200 rounded-full h-1">
            <div className="bg-red-500 h-1 rounded-full animate-progress-bar"></div>
          </div>
        </div>
      </div>
    </div>
  );
};